@if (activeNavigationItem?.action == 'basicConfig') {
    <ei-import-type-basic-component
            [importTypeId]="objectIdentifier.objectId"></ei-import-type-basic-component>
}
@if (activeNavigationItem?.action == 'structures') {
    <ei-import-type-structures-component
            [importTypeId]="objectIdentifier.objectId"></ei-import-type-structures-component>
}
@if (activeNavigationItem?.action == 'rules') {
    <ei-import-type-rules-component
            [importTypeId]="objectIdentifier.objectId"></ei-import-type-rules-component>
}
